import { createContext } from 'react'

export type PreviewKind = 'THEME' | 'BACKGROUND' | 'SOUNDSCAPE' | 'AVATAR' | 'ORBIT'

export interface ActivePreview {
  kind: PreviewKind
  cosmeticId: string
  label: string
  startedAt: number
  durationMs: number
}

export interface StartPreviewInput {
  kind: PreviewKind
  cosmeticId: string
  label: string
  durationMs?: number
}

export interface PreviewContextValue {
  activePreview: ActivePreview | null
  remainingMs: number
  previewAvatarId: string | null
  startPreview: (input: StartPreviewInput) => void
  cancelPreview: () => void
}

export const PreviewContext = createContext<PreviewContextValue | undefined>(undefined)
